export default "__VITE_ASSET__CAZM6v6v__"